import React from "react";
import { useField } from "formik";

import Styles from "./SignupForm.module.css";

function CustomInput({ label, ...props }) {
	const [field, meta] = useField(props);
	// field :name,onChange,onBlur,aand value
	// meta:error,initialError,touched,initialTouched and valuefor input
	console.log("f", field);
	console.log("m", meta);
	return (
		<>
			<div className={Styles.customInput}>
				<label> {label} </label>
				<input
					{...field}
					{...props}
					className={
						meta.touched && meta.error
							? Styles.inputError
							: ""
					}
				/>
				{meta.touched && meta.error && (
					<div className={Styles.error}>{meta.error}</div>
				)}
			</div>
		</>
	);
}

export default CustomInput;
